module.exports = __webpack_public_path__ + "static/media/Snelweg.be980748.mp3";